import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  heading: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: '28px',
    color: '#666666',
  },
  accordion: {
    margin: '0px !important',
    borderTop: '2px solid #ECECEC',
  },
  container: {
    margin: '32px auto',
    width: '80%',
  },
  formLabel: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '20px',
    color: '#666666',
  },
  anomalyDetail: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '16px',
    color: '#666666',
  },
  gridMargin: {
    margin: '15px !important',
  },
  secondaryHeading: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '18px',
    color: '#CCCCCC',
    marginTop: 6,
    marginRight: 46,
    right: 0,
    position: 'absolute',
  },
  listItem: {
    padding: 0,
  },
  expandIcon: {
    color: '#DF0C36',
  },
  downloadButton: {
    color: '#333333',
    cursor: 'pointer',
  },
  warningMessage: {
    '& .MuiFormHelperText-root': {
      color: '#F39C12',
    },
  },
  warningIcon: {
    color: '#F39C12',
  },
  warningMessageDamageCode: {
    '& .MuiFormHelperText-root': {
      color: '#F39C12',
    },
    width: '90%',
  },
  firstAccordion: {
    margin: '0px !important',
    borderTop: '2px solid #DF0C36',
  },
}));
